import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { testimonials } from '../data/content';
import { useConsult } from '../contexts/ConsultContext';
const AVATAR = 'https://cdn.magicpatterns.com/patterns/generated-images/6898409c-5439-4fdc-ac20-76069d9a932d.jpg';
export function Results() {
  const {
    openConsult
  } = useConsult();
  const featured = testimonials.find(t => t.featured) ?? testimonials[0];
  const rest = testimonials.filter(t => t !== featured);
  return <section id="results" className="w-full bg-white py-20 lg:py-28" data-id="element-140" data-mp="1obufa56rrq6b">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8" data-id="element-141" data-mp="232a3ztye9g98">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-142" data-mp="233uxdg8z2t5i">
          <h2 className="max-w-xl font-display text-4xl leading-tight tracking-tight text-ash-900 lg:text-5xl" data-id="element-143" data-mp="1y3gz2px6axko">
            The people who stopped waiting
          </h2>
          <div className="flex items-center gap-3" data-id="element-144" data-mp="274eysw0kwixg">
            <span className="flex gap-0.5" aria-hidden="true" data-id="element-145" data-mp="1m32m9y1lnieu">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-turq-400 text-turq-400" data-id="element-146" data-mp="1r1m9s2vud29b" data-mpi={i} />)}
            </span>
            <span className="text-sm text-ash-600" data-id="element-147" data-mp="1w0798039rhwp">
              <span className="font-semibold text-ash-900" data-id="element-148" data-mp="1w3laf5075l2k">4.8/5</span> from 2,400+ treated patients
            </span>
          </div>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.25fr_1fr]" data-id="element-149" data-mp="250vrx83ly6fx">
          <figure className="flex flex-col rounded-3xl bg-ash-50 p-8 lg:p-12" data-id="element-150" data-mp="2a0qcyv0pc1t2">
            <QuoteIcon className="h-8 w-8 text-turq-400" aria-hidden="true" data-id="element-151" data-mp="29ynjg10cbqjl" />
            <blockquote className="mt-6 font-display text-2xl leading-snug text-ash-900 lg:text-[2rem]" data-id="element-152" data-mp="2esi5vc7byjmd">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-4 pt-10" data-id="element-153" data-mp="2oqxpku412qlu">
              <img src={AVATAR} alt="" className="h-12 w-12 rounded-full object-cover" data-id="element-154" data-mp="2sr83csy2alb9" />
              <div data-id="element-155" data-mp="tmrcxqf6fvag">
                <p className="font-semibold text-ash-900" data-id="element-156" data-mp="tlycf76ta20r">{featured.name}</p>
                <p className="text-sm text-ash-500" data-id="element-157" data-mp="onmzgnl7zbeb">{featured.detail}</p>
              </div>
            </figcaption>
          </figure>

          <div className="grid gap-6" data-id="element-158" data-mp="12g37y3ww41mm">
            {rest.map(item => <figure key={item.name} className="flex h-full flex-col rounded-3xl border border-ash-200 p-8" data-id="element-159" data-mp="xntck8d0a9cy">
                <blockquote className="text-lg leading-relaxed text-ash-700" data-id="element-160" data-mp="1cfbzyr87366c">“{item.quote}”</blockquote>
                <figcaption className="mt-auto pt-6" data-id="element-161" data-mp="17g8sz18nmpvq">
                  <p className="font-semibold text-ash-900" data-id="element-162" data-mp="1lcw2e3hsn8ij">{item.name}</p>
                  <p className="text-sm text-ash-500" data-id="element-163" data-mp="1hclp05ro9ftn">{item.detail}</p>
                </figcaption>
              </figure>)}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start gap-4 rounded-2xl bg-royal-50 p-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-164" data-mp="3n7d6fbiddlye">
          <p className="max-w-xl text-lg font-medium text-ash-900" data-id="element-165" data-mp="38z8kk3vwphbg">
            Consultations are complimentary — you&apos;ll know if you&apos;re a candidate before you spend a dollar.
          </p>
          <Button size="lg" onClick={() => openConsult('results')} data-id="element-166" data-mp="2zagxoa5pdn7e">
            Claim my free consult
          </Button>
        </div>
      </div>
    </section>;
}